import { useState, useEffect, useRef, } from "react";
import { useContext, useMemo } from "react";
import LevelTransmitterIndicator from "../components/LevelTransmitterIndicator";
import Transmitter from "../components/Transmitter";
import ControlValveControlPanel from "../components/ControlValveControlPanel";
import Valve from "../components/Valve";
import "./CrudeTank2.css";
import { WellContext } from "../context/WellContext";
import { AlarmContext } from "../context/AlarmContext";
import { PumpContext } from "../context/PumpContext";
import { ProcessContext } from "../context/ProcessContext";
import Pump from "../components/Pump";
import PumpFaceplate from "../components/PumpFaceplate";
import MDSFaceplate from "../components/MDSFaceplate";
import { PlantStore } from "../engine/PlantStore";
import { usePlantStore } from "../engine/usePlantStore";

import { trackPageVisit } from "../competency/PageTracker";
import TransmitterFaceplate from "../components/TransmitterFaceplate";





function ValveOutput({
    tag,
    value,
    x,
    y,
    r = 0,
    description = "Control Valve Opening"
}) {

    const [hover, setHover] = useState(false);
    const [showFaceplate, setShowFaceplate] = useState(false);

    return (
        <>
            {/* Hover */}
            {hover && (
                <div
                    style={{
                        position: "absolute",
                        left: x + 30,
                        top: y - 5,
                        background: "rgba(0,80,180,.85)",
                        color: "#fff",
                        padding: "5px 8px",
                        borderRadius: "4px",
                        border: "1px solid #4fc3ff",
                        fontSize: "11px",
                        zIndex: 9999,
                        pointerEvents: "none",
                        whiteSpace: "nowrap"
                    }}
                >
                    <strong>{tag}</strong><br />
                    {description}
                </div>
            )}

            {/* Original Valve Output */}
            <div
                onMouseEnter={() => setHover(true)}
                onMouseLeave={() => setHover(false)}
                onClick={() => setShowFaceplate(true)}
                style={{
                    position: "absolute",
                    left: x,
                    top: y,

                    color: "lime",
                    background: "black",

                    fontSize: "10px",
                    padding: "1px 4px",

                    borderRadius: "4px",
                    border: "1px solid #555",

                    transform: `rotate(${r}deg)`,
                    transformOrigin: "center",

                    cursor: "pointer",

                    fontWeight: "bold",

                    minWidth: "22px",
                    textAlign: "center",

                    transition: "0.2s",
                    boxShadow: hover
                        ? "0 0 8px rgba(0,255,255,.7)"
                        : "none"
                }}
            >
                {Number(value).toFixed(1)} %
            </div>

            {showFaceplate && (
                <TransmitterFaceplate
                    tag={tag}
                    value={Number(value)}
                    unit="%"
                    min={0}
                    max={100}
                    HH={100}
                    H={90}
                    L={10}
                    LL={0}
                    description={description}
                    x={x + 35}
                    y={y + 20}
                    onClose={() => setShowFaceplate(false)}
                />
            )}
        </>
    );
}



function CrudeTank2({ setPage }) {

    useEffect(() => {
    
      trackPageVisit("CrudeTank2");
    
    }, []);
  
     const {  valves, toggleValve, updateTransmitter} = useContext(WellContext);

const [hoveredValve, setHoveredValve] = useState(null);
const [showMDS, setShowMDS] = useState(false);
  const {processData,  setProcessData} = useContext(ProcessContext);

     

  const DEFAULT_VALVES = {
  FCV_1305: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_1306: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_1307: { mode: "Manual", opening: 0, sp: "", pv: "" },

};

const [valveData, setValveData] = useState(() => {
  const saved = localStorage.getItem("CrudeTank2_valveData");

  if (!saved) return DEFAULT_VALVES;

  try {
    const parsed = JSON.parse(saved);

    // ✅ Merge saved + default (CRITICAL)
    return {
      FCV_1305: { ...DEFAULT_VALVES.FCV_1305, ...parsed.FCV_1305 },
      FCV_1306: { ...DEFAULT_VALVES.FCV_1306, ...parsed.FCV_1306 },
      FCV_1307: { ...DEFAULT_VALVES.FCV_1307, ...parsed.FCV_1307 },

    };

  } catch {
    return DEFAULT_VALVES;
  }
});



/* ✅ Persist */
  useEffect(() => {
    localStorage.setItem("CrudeTank2_valveData", JSON.stringify(valveData));
  }, [valveData]);

  /* ================= ✅ FIXED UPDATE FUNCTION ================= */
  const updateValveData = (tag, field, value) => {
  setValveData(prev => ({
    ...prev,
    [tag]: {
      ...(prev[tag] || DEFAULT_VALVES[tag]),
      [field]: field === "opening" ? Number(value) || 0 : value
    }
  }));
};

  /* ================= PANEL CONTROL ================= */
  const [openPanels, setOpenPanels] = useState([]);

  const openPanel = (tag) => {
    if (!openPanels.includes(tag)) {
      setOpenPanels(prev => [...prev, tag]);
    }
  };

  const closePanel = (tag) => {
    setOpenPanels(prev => prev.filter(p => p !== tag));
  };


  // ================= PUMP PANEL LOGIC =================

  const [openPumpPanels, setOpenPumpPanels] = useState([]);

const openPumpPanel = (tag) => {
  if (!openPumpPanels.includes(tag)) {
    setOpenPumpPanels(prev => [...prev, tag]);
  }
};

const closePumpPanel = (tag) => {
  setOpenPumpPanels(prev => prev.filter(p => p !== tag));
};





const [panelPos, setPanelPos] = useState({ x: 0, y: 80 });
const [dragging, setDragging] = useState(false);
const offsetRef = useRef({ x: 0, y: 0 });

const handleMouseDown = (e) => {
  setDragging(true);

  offsetRef.current = {
    x: e.clientX - panelPos.x,
    y: e.clientY - panelPos.y,
  };
};

const handleMouseMove = (e) => {
  if (!dragging) return;

  setPanelPos({
    x: e.clientX - offsetRef.current.x,
    y: e.clientY - offsetRef.current.y,
  });
};

const handleMouseUp = () => {
  setDragging(false);
};

useEffect(() => {
  window.addEventListener("mousemove", handleMouseMove);
  window.addEventListener("mouseup", handleMouseUp);

  return () => {
    window.removeEventListener("mousemove", handleMouseMove);
    window.removeEventListener("mouseup", handleMouseUp);
  };
}, [dragging]);








const tagStyle = {
      position: "absolute",
      top: -30,
      left: "50%",
      transform: "translateX(-50%)",

      background: "black",
      color: "#00ffcc",

      fontSize: "13px",
      fontWeight: "bold",

      padding: "3px 8px",
      borderRadius: "4px",

      border: "1px solid #555",

      whiteSpace: "nowrap",
      zIndex: 999
    };




  const xv13013Open = !valves?.XV_13013;
  const xv13014Open = !valves?.XV_13014;
  const xv13015Open = !valves?.XV_13015;
  const xv13016Open = !valves?.XV_13016;
  const xv13017Open = !valves?.XV_13017;
  const xv13018Open = !valves?.XV_13018;
  const xv13019Open = !valves?.XV_13019;
  const xv13020Open = !valves?.XV_13020;
  const xv13021Open = !valves?.XV_13021;
  const xv13022Open = !valves?.XV_13022;
  const xv13023Open = !valves?.XV_13023;
  const xv13024Open = !valves?.XV_13024;



// ================= RETREIVING OF DATA FROM OTHER PAGES VIA LOCAL STROAGE =================
      const { transmitters, flowOverrides } = usePlantStore();
      const MarineTerminalCrudeTank2_1303 = transmitters.MarineTerminalCrudeTank2_1303 || 0;
      const MarineTerminalCrudeTank2_1304 = transmitters.MarineTerminalCrudeTank2_1304 || 0;
      const PipelineImportCrudeTank2_1303 = transmitters.PipelineImportCrudeTank2_1303 || 0;
      const PipelineImportCrudeTank2_1304 = transmitters.PipelineImportCrudeTank2_1304 || 0;
      const LoadingGantryCrudeTank2_1303 = transmitters.LoadingGantryCrudeTank2_1303 || 0;
      const LoadingGantryCrudeTank2_1304 = transmitters.LoadingGantryCrudeTank2_1304 || 0;








/* =========================================================
   PUMP CONTEXT
========================================================= */
const pumpContext = useContext(PumpContext) || {};
const pumpData = pumpContext.pumpData || {};
const togglePump = pumpContext.togglePump || (() => {});
        
/* =========================================================
   P-1304A / P-1304B TRANSFER PUMPS
========================================================= */


/* =========================================================
   PUMP STATUS
========================================================= */

const isP1304AOn =
  pumpData?.["P-1304A"]?.running ?? false;

const isP1304BOn =
  pumpData?.["P-1304B"]?.running ?? false;


/* =========================================================
   SUCTION VALVE
========================================================= */

const P1304A_Active =
  isP1304AOn &&
  xv13022Open;

const P1304B_Active =
  isP1304BOn &&
  xv13022Open;


/* =========================================================
   TOTAL CAPACITY
========================================================= */

const TOTAL_CAPACITY_1304 = 13.547;


/* =========================================================
   RUNNING PUMPS
========================================================= */

const activePumpCount1304 =
[
  P1304A_Active,
  P1304B_Active
].filter(Boolean).length;


/* =========================================================
   CONTROL VALVES
========================================================= */

const FCV1306 =
  Number(
    valveData?.FCV_1306?.opening || 0
  ) / 100;

const FCV1307 =
  Number(
    valveData?.FCV_1307?.opening || 0
  ) / 100;


/* =========================================================
   MINIMUM FLOW BYPASS
   FCV-1306 → V-1304
========================================================= */

/* =========================================================
   TOTAL PUMP OUTPUT
   FCV1306 CONTROLS PUMP LOADING
========================================================= */

const pumpOutputTarget1304 =
(
  P1304A_Active ||
  P1304B_Active
)
  ? TOTAL_CAPACITY_1304 * FCV1307
  : 0;


/* =========================================================
   MINIMUM FLOW BYPASS
   FCV1306 CONTROLS SPLIT
========================================================= */

const bypassFlowTarget1304 =
  pumpOutputTarget1304 * FCV1306;


/* =========================================================
   MAIN DISCHARGE TO BLENDING TANK
========================================================= */

const dischargeFlowTarget1304 =
Math.max(
  pumpOutputTarget1304 -
  bypassFlowTarget1304,
  0
);


/* =========================================================
   FIC_13017
   MAIN DISCHARGE FLOW
========================================================= */

const FIC_13017 = flowOverrides?.FIC_13017 ? 0 : (processData.FIC_13017 ?? 0);

useEffect(() => {

  const lastUpdate =
    Number(
      localStorage.getItem(
        "FIC_13017_LastUpdate"
      )
    ) || Date.now();

  const elapsedSeconds =
    (Date.now() - lastUpdate) / 1000;

  if (elapsedSeconds <= 1) return;

  setProcessData(prev => {

    const current =
      Number(prev.FIC_13017 || 0);

    let next = current;

    const systemActive =
      P1304A_Active ||
      P1304B_Active;

    const target =
      systemActive
        ? dischargeFlowTarget1304
        : 0;

    /* ====================================
       MAXIMUM 100 SCANS
       ==================================== */

    const scans =
      Math.min(
        Math.floor(
          elapsedSeconds * 10
        ),
        100
      );

    for (
      let i = 0;
      i < scans;
      i++
    ) {

      next =
        next +
        (
          target -
          next
        ) * 0.12;

    }

    return {
      ...prev,
      FIC_13017: Number(
        next.toFixed(3)
      )
    };

  });

}, [
  dischargeFlowTarget1304,
  P1304A_Active,
  P1304B_Active
]);



useEffect(() => {

  localStorage.setItem(
    "FIC_13017_LastUpdate",
    String(Date.now())
  );

}, [FIC_13017]);




useEffect(() => {

  const interval =
    setInterval(() => {

      setProcessData(prev => {

        const current =
          prev.FIC_13017 ?? 0;

        if (
          !P1304A_Active &&
          !P1304B_Active
        ) {

          return {
            ...prev,
            FIC_13017: 0
          };

        }

        const next =
          current +
          (
            dischargeFlowTarget1304 -
            current
          ) * 0.12;

        return {

          ...prev,

          FIC_13017:
            Number(
              next.toFixed(3)
            )

        };

      });

    }, 100);

  return () =>
    clearInterval(interval);

}, [
  dischargeFlowTarget1304,
  P1304A_Active,
  P1304B_Active,
  setProcessData
]);


/* =========================================================
   FIC_13018
   MINIMUM FLOW BYPASS
========================================================= */

const FIC_13018 =  processData.FIC_13018 ?? 0;

useEffect(() => {

  const lastUpdate =
    Number(
      localStorage.getItem(
        "FIC_13018_LastUpdate"
      )
    ) || Date.now();

  const elapsedSeconds =
    (Date.now() - lastUpdate) / 1000;

  if (elapsedSeconds <= 1) return;

  setProcessData(prev => {

    const current =
      Number(prev.FIC_13018 || 0);


    const systemActive =
      P1304A_Active ||
      P1304B_Active;

    const target =
      systemActive
        ? bypassFlowTarget1304
        : 0;

    /* ====================================
       MAXIMUM 100 SCANS
       ==================================== */

    const scans =
      Math.min(
        Math.floor(
          elapsedSeconds * 10
        ),
        100
      );

    const factor =
      Math.pow(
        1 - 0.12,
        scans
      );

    const next =
      target -
      (
        target - current
      ) * factor;

    return {
      ...prev,
      FIC_13018: Number(
        next.toFixed(3)
      )
    };

  });

}, [
  bypassFlowTarget1304,
  P1304A_Active,
  P1304B_Active
]);



useEffect(() => {

  localStorage.setItem(
    "FIC_13018_LastUpdate",
    String(Date.now())
  );

}, [FIC_13018]);



useEffect(() => {

  const interval =
    setInterval(() => {

      setProcessData(prev => {

        const current =
          prev.FIC_13018 ?? 0;

        if (
          !P1304A_Active &&
          !P1304B_Active
        ) {

          return {
            ...prev,
            FIC_13018: 0
          };

        }

        const next =
          current +
          (
            bypassFlowTarget1304 -
            current
          ) * 0.12;

        return {

          ...prev,

          FIC_13018:
            Number(
              next.toFixed(3)
            )

        };

      });

    }, 100);

  return () =>
    clearInterval(interval);

}, [
  bypassFlowTarget1304,
  P1304A_Active,
  P1304B_Active,
  setProcessData
]);


/* =========================================================
   INDIVIDUAL PUMP FLOWS
========================================================= */

const P1304A_Flow =
  P1304A_Active
    ? (
        FIC_13017 +
        FIC_13018
      ) / activePumpCount1304
    : 0;

const P1304B_Flow =
  P1304B_Active
    ? (
        FIC_13017 +
        FIC_13018
      ) / activePumpCount1304
    : 0;


/* =========================================================
   TOTAL PUMP OUTPUT
========================================================= */

const TotalPumpFlow1304 =
  FIC_13017 +
  FIC_13018;


/* =========================================================
   DISCHARGE PRESSURE
========================================================= */

const PT_1306 =
(
  P1304A_Active ||
  P1304B_Active
)
  ? 1.8
  : 0.03;


/* =========================================================
   DISCHARGE TEMPERATURE
========================================================= */

const TT_1306 =
(
  P1304A_Active ||
  P1304B_Active
)
  ? 37
  : 27;


/* =========================================================
   SYSTEM STATUS
========================================================= */

const transferPump1304Running =
(
  P1304A_Active ||
  P1304B_Active
);










/* =========================================================
   P-1303A / P-1303B TRANSFER PUMPS
========================================================= */


/* =========================================================
   PUMP STATUS
========================================================= */

const isP1303AOn =
  pumpData?.["P-1303A"]?.running ?? false;

const isP1303BOn =
  pumpData?.["P-1303B"]?.running ?? false;


/* =========================================================
   EFFECTIVE RUNNING STATUS
========================================================= */

const P1303A_Active =
  isP1303AOn &&
  xv13021Open;

const P1303B_Active =
  isP1303BOn &&
  xv13021Open;


/* =========================================================
   FCV OPENING
========================================================= */

const fcv1305Opening =
  Number(
    valveData?.FCV_1305?.opening || 0
  );

  /* =========================================================
   RUNNING PUMPS
========================================================= */

const activePumpCount =
  [
    P1303A_Active,
    P1303B_Active
  ].filter(Boolean).length;


  /* =========================================================
   TOTAL PUMP CAPACITY
========================================================= */

const TOTAL_CAPACITY = 12.567;


/* =========================================================
   FLOW PER PUMP
========================================================= */

const P1303A_Flow =
  P1303A_Active
    ? (
        TOTAL_CAPACITY *
        (fcv1305Opening / 100)
      ) / activePumpCount
    : 0;


const P1303B_Flow =
  P1303B_Active
    ? (
        TOTAL_CAPACITY *
        (fcv1305Opening / 100)
      ) / activePumpCount
    : 0;


    /* =========================================================
   TOTAL TARGET FLOW
========================================================= */

const targetFlow =
  P1303A_Flow +
  P1303B_Flow;


  /* =========================================================
   FIC-13019
========================================================= */

const FIC_13019 =  flowOverrides?.FIC_13019 ? 0 : (processData.FIC_13019 ?? 0);

useEffect(() => {

  const lastUpdate =
    Number(
      localStorage.getItem(
        "FIC_13019_LastUpdate"
      )
    ) || Date.now();

  const elapsedSeconds =
    (Date.now() - lastUpdate) / 1000;

  if (elapsedSeconds <= 1) return;

  setProcessData(prev => {

    const current =
      Number(prev.FIC_13019 || 0);

    const systemActive =
      P1303A_Active ||
      P1303B_Active;

    const target =
      systemActive
        ? targetFlow
        : 0;

    /* ====================================
       MAXIMUM 100 SCANS
       ==================================== */

    const scans =
      Math.min(
        Math.floor(
          elapsedSeconds * 10
        ),
        100
      );

    const factor =
      Math.pow(
        1 - 0.12,
        scans
      );

    const next =
      target -
      (
        target - current
      ) * factor;

    return {
      ...prev,
      FIC_13019: Number(
        next.toFixed(3)
      )
    };

  });

}, [
  targetFlow,
  P1303A_Active,
  P1303B_Active
]);



useEffect(() => {

  localStorage.setItem(
    "FIC_13019_LastUpdate",
    String(Date.now())
  );

}, [FIC_13019]);


useEffect(() => {

  const interval = setInterval(() => {

    setProcessData(prev => {

      const current =
        prev.FIC_13019 ?? 0;

      const systemActive =
        P1303A_Active ||
        P1303B_Active;

      if (
        !systemActive ||
        targetFlow === 0
      ) {

        return {
          ...prev,
          FIC_13019: 0
        };

      }

      const next =
        current +
        (targetFlow - current) * 0.12;

      return {

        ...prev,

        FIC_13019:
          Number(
            next.toFixed(3)
          )

      };

    });

  }, 100);

  return () =>
    clearInterval(interval);

}, [
  targetFlow,
  P1303A_Active,
  P1303B_Active,
  setProcessData
]);

/* =========================================================
   PT-1305
========================================================= */

const PT_1305 =
  (
    P1303A_Active ||
    P1303B_Active
  )
    ? Number(
        (
          0.03 +
          (
            1.8 - 0.03
          ) *
          (fcv1305Opening / 100)
        ).toFixed(2)
      )
    : 0.03;


    /* =========================================================
   TT-1305
========================================================= */

const TT_1305 =
  (
    P1303A_Active ||
    P1303B_Active
  )
    ? 37
    : 27;

  


/* =========================================================
              SPLITTING MAIN LINE OF P-1303A/B
========================================================= */

const openBranchCount =
[
  xv13023Open,
  xv13024Open
].filter(Boolean).length;

const FIC_13020 =
  xv13024Open
    ? FIC_13019 / openBranchCount
    : 0;

const FIC_13021 =
  xv13023Open
    ? FIC_13019 / openBranchCount
    : 0;








    const FIC_13015 = xv13020Open ? MarineTerminalCrudeTank2_1303 + PipelineImportCrudeTank2_1303 + LoadingGantryCrudeTank2_1303  + FIC_13018: 0;
    const FIC_13016 = xv13016Open ? MarineTerminalCrudeTank2_1304 + PipelineImportCrudeTank2_1304 + LoadingGantryCrudeTank2_1304: 0;

    const TT_1307 = xv13020Open ? 37.983 : 35.433;
    const TT_1308 = xv13016Open ? 37.983 : 35.433;



          useEffect(() => {
            localStorage.setItem("FIC_13017", FIC_13017);
          }, [FIC_13017]);

          useEffect(() => {
            localStorage.setItem("FIC_13020", FIC_13020);
          }, [FIC_13020]);
 
useEffect(() => {

  const current =
    PlantStore.get().transmitters;


  if (
    current.FIC_13017 === FIC_13017 && 
    current.FIC_13020 === FIC_13020 &&
    current.FIC_13021 === FIC_13021 
  ) {
    return;
  }


  PlantStore.set({
    transmitters: {

      ...current,
      FIC_13017, FIC_13020, FIC_13021
    }
  });

}, [FIC_13017, FIC_13020, FIC_13021 ]);



  return (
    <div className="CrudeTank2-container">

      {/* TITLE */}
      <h2
        style={{
          position: "absolute",
          top: "0px",
          left: "215px",
          color: "white",
          background: "rgb(30, 5, 250)",
          padding: "2px 305px",
          zIndex: 10,
        }}
      >
        CRUDE STORAGE TANKS 2
      </h2>


 {/* =================SHUTDOWN VALVES ================= */}

      
      {/* XV-13013 */}
      <Valve
        className="XV-13013"
        tag="XV_13013"
        x={189}
        y={338}
        isClosed={valves.XV_13013}
        toggle={toggleValve}
        r={90}
      />

      {/* XV-13014 */}
      <Valve
        className="XV-13014"
        tag="XV_13014"
        x={299}
        y={393}
        isClosed={valves.XV_13014}
        toggle={toggleValve}
        r={90}
      />

      {/* XV-13015 */}
      <Valve
        className="XV-13015"
        tag="XV_13015"
        x={256}
        y={338}
        isClosed={valves.XV_13015}
        toggle={toggleValve}
        r={90}
      />

      {/* XV-13016 */}
      <Valve
        className="XV-13016"
        tag="XV_13016"
        x={719}
        y={246}
        isClosed={valves.XV_13016}
        toggle={toggleValve}
      />

      {/* XV-13017 */}
      <Valve
        className="XV-13017"
        tag="XV_13017"
        x={600}
        y={359}
        isClosed={valves.XV_13017}
        toggle={toggleValve}

      />

      {/* XV-13018 */}
      <Valve
        className="XV-13018"
        tag="XV_13018"
        x={729}
        y={388}
        isClosed={valves.XV_13018}
        toggle={toggleValve}
        r={90}
      />

      {/* XV-13019 */}
      <Valve
        className="XV-13019"
        tag="XV_13019"
        x={671}
        y={395}
        isClosed={valves.XV_13019}
        toggle={toggleValve}
        r={90}
      />

      {/* XV-13020 */}
      <Valve
        className="XV-13020"
        tag="XV_13020"
        x={278}
        y={245}
        isClosed={valves.XV_13020}
        toggle={toggleValve}
      />

      
      {/* XV-13021 */}
      <Valve
        className="XV-13021"
        tag="XV_13021"
        x={575}
        y={279}
        isClosed={valves.XV_13021}
        toggle={toggleValve}
        r={90}
      />

      {/* XV-13022 */}
      <Valve
        className="XV-13022"
        tag="XV_13022"
        x={1011}
        y={278}
        isClosed={valves.XV_13022}
        toggle={toggleValve}
        r={90}
      />

      {/* XV-13023 */}
      <Valve
        className="XV-13023"
        tag="XV_13023"
        x={1074}
        y={656}
        isClosed={valves.XV_13023}
        toggle={toggleValve}
      />

      {/* XV-13024 */}
      <Valve
        className="XV-13024"
        tag="XV_13024"
        x={1064}
        y={577}
        isClosed={valves.XV_13024}
        toggle={toggleValve}
      />

      



      
        {/* ================= CONTROL VALVES SVG ================= */}
        

         {/* FCV-1305 */}
        <div
            style={{ position: "absolute", left: 860, top: 566}}
            onMouseEnter={() => setHoveredValve("FCV_1305")}
            onMouseLeave={() => setHoveredValve(null)}
            onClick={() => openPanel("FCV_1305")}
          >

            {hoveredValve === "FCV_1305" && (
              <div style={tagStyle}>
                FCV_1305
              </div>
            )}

            <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-1305">
                    
          <defs>
            <linearGradient id="metal_1305">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>


          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_1305)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_1305)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>
      </div>


         
         {/* FCV-1306 */}
        <div
            style={{ position: "absolute", left: 1060, top: 294}}
            onMouseEnter={() => setHoveredValve("FCV_1306")}
            onMouseLeave={() => setHoveredValve(null)}
            onClick={() => openPanel("FCV_1306")}
          >

            {hoveredValve === "FCV_1306" && (
              <div style={tagStyle}>
                FCV_1306
              </div>
            )}

            <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-1306">
          
          
          <defs>
            <linearGradient id="metal_1306">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>


          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_1306)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_1306)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>
      </div>

         
         {/* FCV-1307 */}
        <div
            style={{ position: "absolute", left: 1151, top: 407}}
            onMouseEnter={() => setHoveredValve("FCV_1307")}
            onMouseLeave={() => setHoveredValve(null)}
            onClick={() => openPanel("FCV_1307")}
          >

            {hoveredValve === "FCV_1307" && (
              <div style={tagStyle}>
                FCV_1307
              </div>
            )}

            <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-1307">
          
          
          <defs>
            <linearGradient id="metal_1307">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>


          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_1307)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_1307)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>
      </div>



        
        {/* ================= CONTROL VALVE FACEPLATES ================= */}
          {openPanels.map((tag, index) => (
            <ControlValveControlPanel
              key={tag}
              tag={tag}
              data={valveData?.[tag] ?? DEFAULT_VALVES?.[tag]}
              update={updateValveData}
              close={() => closePanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 150 + index * 40
              }}
            />
          ))}

           {/* ================= PUMPS CONTROL VALVE FACEPLATES ================= */}
          {openPumpPanels.map((tag, index) => (
            <PumpFaceplate
              key={tag}
              tag={tag}
              close={() => closePumpPanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 150 + index * 40
              }}
            />
          ))}



          {/* ================= MDS FACEPLATE ================= */}

          {showMDS && (
            <MDSFaceplate
                close={() => setShowMDS(false)}
                tankID={2}
                storageKey="TANK2_SELECTED_CRUDE"
                mode="tank"
            />
          )}

           

      {/* ================= CONTROL VALVE OUTPUTS ================= */}

      <ValveOutput
        value={Number(valveData?.FCV_1305?.opening || 0)}
        x={881}
        y={610}
      />

      <ValveOutput
        value={Number(valveData?.FCV_1306?.opening || 0)}
        x={1082}
        y={341}
      />

      <ValveOutput
        value={Number(valveData?.FCV_1307?.opening || 0)}
        x={1171}
        y={451}
      />




        <button
          onClick={() => setShowMDS(true)}
          style={{
            position: "absolute",
            top: "300px",
            left: "100px",
            padding: "5px 2px",
            background: "#ff9800",
            color: "#000",
            border: "none",
            borderRadius: "4px",
            fontWeight: "bold",
            cursor: "pointer",
            zIndex: 500
          }}
        >
          Crude MDS
        </button>





                  <Transmitter
                    tag="FIC_13015"
                    value={FIC_13015}
                    x={182}
                    y={221}
                    unit="BPM"
                    max={300}
                    HH={248}
                    H={245}
                    L={5}
                    LL={3}
                    c="lime"
                    description="FLOWRATE OF CRUDE FROM MARINE TERMINAL TO SUCTION V-1303"
                   />
          
                  <Transmitter
                    tag="FIC_13016"
                    value={FIC_13016}
                    x={682}
                    y={207}
                    unit="BPM"
                    max={300}
                    HH={248}
                    H={245}
                    L={5}
                    LL={3}
                    c="lime"
                    description="FLOWRATE OF CRUDE FROM MARINE TERMINAL TO SUCTION V-1304"
                   />

                   
         <Transmitter
          tag="FIC_13017"
          value={[FIC_13017]}
          x={1225}
          y={463}
          unit="BPM"
          max={17}
          HH={16}
          H={45}
          L={0}
          LL={0}
          c="lime"
          description="FLOWRATE OF CRUDE TRANSFER PUMPS (P-1304A/B) FROM V-1304 TO BLENDING TANK"
         />

         <Transmitter
          tag="FIC_13018"
          value={[FIC_13018]}
          x={1142}
          y={288}
          unit="BPM"
          max={17}
          HH={16}
          H={45}
          L={0}
          LL={0}
          c="lime"
          description="FLOWRATE OF CRUDE TRANSFER PUMPS (P-1304A/B) MINIMUM FLOW BYEPASS LINE FROM V-1304 TO V-1303 TANK"
         />

         <Transmitter
          tag="PT_1306"
          value={[PT_1306]}
          x={1084}
          y={447}
          unit="MPa"
          max={3}
          HH={2.5}
          H={1.8}
          L={0}
          LL={0}
          c="lime"
          description="PRESSURE OF CRUDE TRANSFER PUMPS (P-1304A/B) MINIMUM FLOW BYEPASS LINE FROM V-1304 TO BLENDING TANK"
         />

         <Transmitter
          tag="TT_1306"
          value={[TT_1306]}
          x={1217}
          y={358}
          unit="°C"
          max={70}
          HH={56}
          H={45}
          L={0}
          LL={0}
          c="lime"
          description="TEMPERATURE OF CRUDE TRANSFER PUMPS (P-1304A/B) MINIMUM FLOW BYEPASS LINE FROM V-1304 TO BLENDING TANK"
         />

       
         <Transmitter
          tag="FIC_13019"
          value={[FIC_13019]}
          x={642}
          y={563}
          unit="BPM"
          max={17}
          HH={16}
          H={45}
          L={0}
          LL={0}
          c="lime"
          description="FLOWRATE OF CRUDE TRANSFER PUMPS (P-1303A/B) MINIMUM FLOW BYEPASS LINE FROM V-1303 TO BLENDING TANK OR DAY TANK"
         />

         <Transmitter
          tag="PT_1305"
          value={[PT_1305]}
          x={536}
          y={588}
          unit="MPa"
          max={3}
          HH={2.5}
          H={1.8}
          L={0}
          LL={0}
          c="lime"
          description="PRESSURE OF CRUDE TRANSFER PUMPS (P-1303A/B) MINIMUM FLOW BYEPASS LINE FROM V-1303 TO BLENDING TANK OR DAY TANK"
         />

         <Transmitter
          tag="TT_1305"
          value={[TT_1305]}
          x={752}
          y={563}
          unit="°C"
          max={70}
          HH={56}
          H={45}
          L={0}
          LL={0}
          c="lime"
          description="TEMPERATURE OF CRUDE TRANSFER PUMPS (P-1303A/B) MINIMUM FLOW BYEPASS LINE FROM V-1303 TO BLENDING TANK OR DAY TANK"
         />

         <Transmitter
          tag="TT_1307"
          value={[TT_1307]}
          x={332}
          y={68}
          unit="°C"
          max={70}
          HH={56}
          H={45}
          L={0}
          LL={0}
          c="lime"
          description="TEMPERATURE OF CRUDE ON TANK V-1303"
         />

         <Transmitter
          tag="TT_1308"
          value={[TT_1308]}
          x={752}
          y={68}
          unit="°C"
          max={70}
          HH={56}
          H={45}
          L={0}
          LL={0}
          c="lime"
          description="TEMPERATURE OF CRUDE ON TANK V-1304"
         />


                
         <Transmitter
          tag="FIC_13020"
          value={[FIC_13020]}
          x={1132}
          y={563}
          unit="BPM"
          max={17}
          HH={16}
          H={45}
          L={0}
          LL={0}
          c="lime"
          description="FLOWRATE OF CRUDE TRANSFER PUMPS (P-1303A/B) FROM V-1303 TO BLENDING TANK"
         />

       
                
         <Transmitter
          tag="FIC_13021"
          value={[FIC_13021]}
          x={1132}
          y={638}
          unit="BPM"
          max={17}
          HH={16}
          H={45}
          L={0}
          LL={0}
          c="lime"
          description="FLOWRATE OF CRUDE TRANSFER PUMPS (P-1303A/B) FROM V-1303 TO DAY TANK"
         />

       



                   
    <LevelTransmitterIndicator
      tag="LT_1303"
      totalLevel={70000}
      inflows={[FIC_13015]}
      outflows={[FIC_13019]}
      inflowTags={["FIC_13015"]}
      outflowTags={["FIC_13019"]}
      responseFactor={0.05}
      columnX={491}
      columnY={130}
      columnWidth={30}
      columnHeight={173}
      textX={535}
      textY={140}
      showFlow={true}
      backgroundOpacity={0.01}
      liquidOpacity={0.9}
      service="crude"
    />

    <LevelTransmitterIndicator
      tag="LT_1303"
      totalLevel={70000}
      inflows={[FIC_13015]}
      outflows={[FIC_13019]}
      inflowTags={["FIC_13015"]}
      outflowTags={["FIC_13019"]}
      responseFactor={0.05}
      columnX={341}
      columnY={130}
      columnWidth={182}
      columnHeight={173}
      textX={535}
      textY={140}
      showFlow={true}
      backgroundOpacity={0.01}
      liquidOpacity={0.1}
      service="crude"
    />

    <LevelTransmitterIndicator
      tag="LT_1304"
      totalLevel={70000}
      inflows={[FIC_13016]}
      outflows={[FIC_13017]}
      inflowTags={["FIC_13016"]}
      outflowTags={["FIC_13017"]}
      responseFactor={0.05}
      columnX={929}
      columnY={130}
      columnWidth={30}
      columnHeight={173}
      textX={969}
      textY={140}
      showFlow={true}
      backgroundOpacity={0.01}
      liquidOpacity={0.9}
      service="crude"
    />

    <LevelTransmitterIndicator
      tag="LT_1304"
      totalLevel={70000}
      inflows={[FIC_13016]}
      outflows={[FIC_13017]}
      responseFactor={0.05}
      inflowTags={["FIC_13016"]}
      outflowTags={["FIC_13017"]}
      columnX={778}
      columnY={130}
      columnWidth={182}
      columnHeight={173}
      textX={969}
      textY={140}
      showFlow={true}
      backgroundOpacity={0.01}
      liquidOpacity={0.1}
      service="crude"
    />




    
            <Pump
              tag="P-1303A"
              x={468}
              y={542}
              rpm={1800}
              bladeCount={pumpData?.["P-1303A"]?.bladeCount || 3}
              size={pumpData?.["P-1303A"]?.size || 38}
              onClick={openPumpPanel}
            />

            <Pump
              tag="P-1303B"
              x={468}
              y={635}
              rpm={1800}
              bladeCount={pumpData?.["P-1303B"]?.bladeCount || 3}
              size={pumpData?.["P-1303B"]?.size || 38}
              onClick={openPumpPanel}
            />


    
            <Pump
              tag="P-1304A"
              x={1050}
              y={398}
              rpm={1800}
              bladeCount={pumpData?.["P-1304A"]?.bladeCount || 3}
              size={pumpData?.["P-1304A"]?.size || 38}
              onClick={openPumpPanel}
            />

            <Pump
              tag="P-1304B"
              x={1050}
              y={484}
              rpm={1800}
              bladeCount={pumpData?.["P-1304B"]?.bladeCount || 3}
              size={pumpData?.["P-1304B"]?.size || 38}
              onClick={openPumpPanel}
            />






    </div>
  );
}

export default CrudeTank2;